module.exports = __webpack_public_path__ + "static/img/fz_zzb_tz.ca2a2ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_zzb_tz.png
// module id = sp0L
// module chunks = 0